import { makeApiRequest } from './apiBody';
// ────────────────────────────────────────────────
// CREATE full config
// ────────────────────────────────────────────────
async function createDmvicConfig(configData) {
  console.log("config dvic server", configData)
  try {
    const data = {
      config: {
        credentials: {
          username: configData.username,
          password: configData.password,
          clientId: configData.clientId,
        },
        members: {
          underwriterRef: "",
          memberId: 0,
        },
        issuanceConfig: {
          validateBeforeIssuance: configData.validateBeforeIssuance ?? true,
          autoConfirmRiskChanges: configData.autoConfirmRiskChanges ?? false,
          defaultPin: configData.defaultPin || "",
          defaultEmail: configData.defaultEmail,
          defaultPhone: configData.defaultPhone,
        },
      },
    };

    const response = await makeApiRequest({
      serviceName: 'intergration',
      resourceName: 'intermediaryDmvicConfig',
      actionName: 'createConfig',
      data,
    });

    return response;
  } catch (err) {
    throw err; // let caller handle
  }
}

// ────────────────────────────────────────────────
// UPDATE (partial) config
// ────────────────────────────────────────────────
async function updateDmvicConfig(values, systemRef) {
  try {
    const data = {
    "intermediaryDmvicConfigSystemRef": systemRef,
    "credentials": {
      "username":  values.username,
      "password":   values.password,
      "clientId":  values.clientId
    },
    "issuanceConfig": {
      "validateBeforeIssuance": values.isValidatedBeforeIssuance,
      "autoConfirmRiskChanges": values.isAutoConfirmRiskChanges,
      "defaultPin": values.defaultPin,
      "defaultEmail": values.defaultEmail,
      "defaultPhone": values.defaultPhone
    }
  }

    const response = await makeApiRequest({
      serviceName: 'intergration',
      resourceName: 'intermediaryDmvicConfig',
      actionName: 'updateConfig',
      data,
    });

    return response;
  } catch (err) {
    throw err;
  }
}

// ────────────────────────────────────────────────
// GET config
// ────────────────────────────────────────────────
async function getDmvicConfig() {
  try {
    const data = {
    };

    const response = await makeApiRequest({
      serviceName: 'intergration',
      resourceName: 'intermediaryDmvicConfig',
      actionName: 'getConfig',
      data,
    });

    return response;
  } catch (err) {
    throw err;
  }
}

// ────────────────────────────────────────────────
// DELETE config
// ────────────────────────────────────────────────
async function deleteDmvicConfig(systemRef) {
  try {
    const data = {
      intermediaryDmvicConfigSystemRef: systemRef,
    };

    const response = await makeApiRequest({
      serviceName: 'intergration',
      resourceName: 'intermediaryDmvicConfig',
      actionName: 'deleteConfig',
      data,
    });

    // Optional cleanup
    sessionStorage.removeItem("dmvicConfigRef");

    return response;
  } catch (err) {
    throw err;
  }
}

// ────────────────────────────────────────────────
// APPEND member
// ────────────────────────────────────────────────
async function appendDmvicMember(memberData) {
  try {
    const data = {
      member: {
        underwriterRef: memberData.underwriterRef,
        memberId: Number(memberData.memberId),
      },
    };

    const response = await makeApiRequest({
      serviceName: 'intergration',
      resourceName: 'intermediaryDmvicConfig',
      actionName: 'appendMember',
      data,
    });

    return response;
  } catch (err) {
    throw err;
  }
}

// ────────────────────────────────────────────────
// REMOVE member
// ────────────────────────────────────────────────
async function removeDmvicMember(underwriterRef) {
  try {
    const data = {
      underwriterRef,
    };

    const response = await makeApiRequest({
      serviceName: 'intergration',
      resourceName: 'intermediaryDmvicConfig',
      actionName: 'removeMember',
      data,
    });

    return response;
  } catch (err) {
    throw err;
  }
}

export {
  createDmvicConfig,
  updateDmvicConfig,
  getDmvicConfig,
  deleteDmvicConfig,
  appendDmvicMember,
  removeDmvicMember,
};